import React from 'react';

import { InsuranceForm } from 'components/InsuranceForm/InsuranceForm';
import { InsuranceProvider } from 'components/InsuranceForm/InsuranceForm.types';
import { COB_PRIORITY_CODE } from 'components/InsuranceForm/InsuranceForm.utils';
import { Modal } from 'components/v2/Modal/Modal';
interface Props {
  title: string;
  open: boolean;
  cobPriorityCode?: COB_PRIORITY_CODE;
  insuranceProvider?: InsuranceProvider;
  onClose: () => void;
  onSuccess: () => void;
}

const MODAL_MAX_WIDTH = 880;

export const InsuranceModalForm = ({
  title,
  open,
  cobPriorityCode,
  insuranceProvider,
  onClose,
  onSuccess
}: Props) => {
  return (
    <Modal title={title} open={open} onCancel={onClose} maxWidth={MODAL_MAX_WIDTH}>
      <InsuranceForm
        insuranceProvider={insuranceProvider}
        cobPriorityCode={cobPriorityCode}
        onSuccess={onSuccess}
      />
    </Modal>
  );
};
